import { lazy } from 'react';

const ActivityJournalsPage = lazy(() => import('../components/activityJournalsView'));

export default ActivityJournalsPage;
